import { useState, useEffect, createContext, useContext, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('ths_token'));

  // 初始化：只执行一次，检查 localStorage 中的 token
  useEffect(() => {
    const savedToken = localStorage.getItem('ths_token');
    if (savedToken) {
      setToken(savedToken);
      // 从 localStorage 恢复用户信息（立即显示）
      try {
        const savedUser = JSON.parse(localStorage.getItem('ths_user'));
        if (savedUser) setUser(savedUser);
      } catch {}
      // 尝试获取用户信息（失败不清 token）
      api.get('/auth/profile')
        .then(res => {
          if (res.data.success) {
            setUser(res.data.data);
          }
        })
        .catch(() => {
          // 网络失败不清 token，后续 API 请求靠拦截器带 token
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (username, password) => {
    const res = await api.post('/auth/login', { username, password });
    if (res.data.success) {
      const { token: newToken, user: userData } = res.data.data;
      localStorage.setItem('ths_token', newToken);
      localStorage.setItem('ths_user', JSON.stringify(userData));
      setToken(newToken);
      setUser(userData);
    }
    return res.data;
  }, []);

  const register = useCallback(async (username, password, nickname) => {
    const res = await api.post('/auth/register', { username, password, nickname });
    return res.data;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post('/auth/logout'); } catch (e) { /* ignore */ }
    localStorage.removeItem('ths_token');
    localStorage.removeItem('ths_user');
    setToken(null);
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
